// import React, { useState, useEffect } from 'react';
// import { FaFileAlt, FaEye, FaDownload, FaFilter, FaImage, FaFilePdf, FaExclamationTriangle, FaUser, FaCalendar, FaProjectDiagram } from 'react-icons/fa';
// import axios from 'axios';

// const AdminDisputesDashboard = () => {
//   const [disputes, setDisputes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedDispute, setSelectedDispute] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [filters, setFilters] = useState({
//     status: '',
//     raisedBy: '',
//     search: ''
//   });
//   const [pagination, setPagination] = useState({
//     current: 1,
//     total: 1,
//     count: 0,
//     totalRecords: 0
//   });
//   const [resolving, setResolving] = useState(false);
//   const [resolutionData, setResolutionData] = useState({
//     status: '',
//     adminDecision: '',
//     resolutionNotes: ''
//   });
//   const [activeTab, setActiveTab] = useState('details');
//   const [error, setError] = useState(null);

//   // Fetch disputes from API
//   const fetchDisputes = async (page = 1) => {
//     try {
//       setLoading(true);
//       setError(null);

//       const params = {
//         page,
//         limit: 10,
//         ...filters
//       };

//       // Remove empty filter values
//       Object.keys(params).forEach(key => {
//         if (params[key] === '' || params[key] === null || params[key] === undefined) {
//           delete params[key];
//         }
//       });

//       const response = await axios.get('/admin/disputes', { params });

//       if (response.data.success) {
//         setDisputes(response.data.disputes);
//         setPagination(response.data.pagination);
//       } else {
//         setError('Failed to fetch disputes');
//       }
//     } catch (error) {
//       console.error('Error fetching disputes:', error);
//       setError(error.response?.data?.error || 'Failed to fetch disputes');
//       setDisputes([]);
//       setPagination({ current: 1, total: 1, count: 0, totalRecords: 0 });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch detailed dispute information
//   const fetchDisputeDetails = async (disputeId) => {
//     try {
//       const response = await axios.get(`/admin/dispute/${disputeId}`);
//       if (response.data.success) {
//         setSelectedDispute(response.data.dispute);
//         setShowModal(true);
//       } else {
//         alert('Failed to fetch dispute details');
//       }
//     } catch (error) {
//       console.error('Error fetching dispute details:', error);
//       alert(error.response?.data?.error || 'Failed to fetch dispute details');
//     }
//   };

//   // Update dispute status
//   const updateDisputeStatus = async () => {
//     if (!selectedDispute || !resolutionData.status) {
//       alert('Please select a status');
//       return;
//     }

//     try {
//       setResolving(true);
//       const response = await axios.put(`/admin/dispute/${selectedDispute._id}/status`, resolutionData);

//       if (response.data.success) {
//         alert('Dispute updated successfully');
//         setShowModal(false);
//         fetchDisputes(pagination.current); // Refresh current page
//         setResolutionData({ status: '', adminDecision: '', resolutionNotes: '' });
//       }
//     } catch (error) {
//       console.error('Error updating dispute:', error);
//       alert(error.response?.data?.error || 'Failed to update dispute');
//     } finally {
//       setResolving(false);
//     }
//   };

//   const getStatusBadge = (status) => {
//     const variants = {
//       'open': 'bg-red-100 text-red-800',
//       'under-review': 'bg-yellow-100 text-yellow-800',
//       'resolved': 'bg-green-100 text-green-800',
//       'rejected': 'bg-gray-100 text-gray-800'
//     };
//     return variants[status] || 'bg-gray-100 text-gray-800';
//   };

//   const getFileIcon = (type) => {
//     if (type.startsWith('image/')) return <FaImage className="text-blue-500" />;
//     if (type === 'application/pdf') return <FaFilePdf className="text-red-500" />;
//     return <FaFileAlt className="text-gray-500" />;
//   };

//   const formatFileSize = (bytes) => {
//     if (bytes === 0) return '0 Bytes';
//     const k = 1024;
//     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(k));
//     return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
//   };

//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({ ...prev, [key]: value }));
//   };

//   const applyFilters = () => {
//     fetchDisputes(1);
//   };

//   const clearFilters = () => {
//     setFilters({ status: '', raisedBy: '', search: '' });
//     setTimeout(() => fetchDisputes(1), 100);
//   };

//   // Get display name for dispute creator
//   const getCreatorName = (dispute) => {
//     if (dispute.raisedBy === 'client') {
//       return dispute.projectId?.clientId?.name || 'Client';
//     } else {
//       return dispute.projectId?.sellerId?.name || 'Seller';
//     }
//   };

//   useEffect(() => {
//     fetchDisputes();
//   }, []);

//   return (
//     <div className="max-w-7xl mx-auto p-6">
//       {/* Header */}
//       <div className="mb-6">
//         <div className="flex items-center mb-2">
//           <FaExclamationTriangle className="mr-3 text-yellow-500" size={24} />
//           <h1 className="text-2xl font-bold text-gray-900">Dispute Management Dashboard</h1>
//         </div>
//         <p className="text-gray-600">Manage and resolve project disputes</p>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
//           <div className="flex items-center">
//             <FaExclamationTriangle className="text-red-500 mr-2" />
//             <p className="text-red-700">{error}</p>
//           </div>
//         </div>
//       )}

//       {/* Filters */}
//       <div className="bg-white rounded-lg shadow-sm border p-6 mb-6">
//         <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
//             <select
//               value={filters.status}
//               onChange={(e) => handleFilterChange('status', e.target.value)}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//             >
//               <option value="">All Statuses</option>
//               <option value="open">Open</option>
//               <option value="under-review">Under Review</option>
//               <option value="resolved">Resolved</option>
//               <option value="rejected">Rejected</option>
//             </select>
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">Raised By</label>
//             <select
//               value={filters.raisedBy}
//               onChange={(e) => handleFilterChange('raisedBy', e.target.value)}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//             >
//               <option value="">All Users</option>
//               <option value="client">Clients</option>
//               <option value="seller">Sellers</option>
//             </select>
//           </div>
//           <div className="md:col-span-2">
//             <label className="block text-sm font-medium text-gray-700 mb-2">Search</label>
//             <input
//               type="text"
//               placeholder="Search by dispute code, project..."
//               value={filters.search}
//               onChange={(e) => handleFilterChange('search', e.target.value)}
//               className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>
//           <div className="flex gap-2">
//             <button
//               onClick={applyFilters}
//               className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center"
//             >
//               <FaFilter className="mr-2" size={16} />
//               Filter
//             </button>
//             <button
//               onClick={clearFilters}
//               className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
//             >
//               Clear
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Disputes Table */}
//       <div className="bg-white rounded-lg shadow-sm border">
//         <div className="px-6 py-4 border-b border-gray-200">
//           <h2 className="text-lg font-semibold text-gray-900">
//             Disputes ({pagination.totalRecords})
//           </h2>
//         </div>

//         {loading ? (
//           <div className="text-center py-12">
//             <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
//             <p className="mt-4 text-gray-500">Loading disputes...</p>
//           </div>
//         ) : disputes.length === 0 ? (
//           <div className="text-center py-12">
//             <FaExclamationTriangle size={48} className="text-gray-400 mx-auto mb-4" />
//             <h3 className="text-lg font-medium text-gray-900 mb-2">No Disputes Found</h3>
//             <p className="text-gray-500">No disputes match your current filters.</p>
//           </div>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Dispute Code
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Created By
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Against
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Project
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Status
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Created
//                   </th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {disputes.map((dispute) => (
//                   <tr key={dispute._id} className="hover:bg-gray-50">
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className="font-semibold text-blue-600">{dispute.disputeCode}</span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <FaUser className="mr-2 text-gray-400" size={16} />
//                         <div>
//                           <div className="text-sm font-medium text-gray-900">
//                             {dispute.raisedBy === 'client' ? 'Client' : 'Seller'}
//                           </div>
//                           <div className="text-sm text-gray-500">
//                             {getCreatorName(dispute)}
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <FaUser className="mr-2 text-gray-400" size={16} />
//                         <div>
//                           <div className="text-sm font-medium text-gray-900">{dispute.againstUser?.name}</div>
//                           <div className="text-sm text-gray-500">{dispute.againstUser?.email}</div>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <FaProjectDiagram className="mr-2 text-gray-400" size={16} />
//                         <div>
//                           <div className="text-sm font-medium text-gray-900">{dispute.projectId?.title}</div>
//                           {dispute.milestoneId && (
//                             <div className="text-sm text-gray-500">
//                               Milestone: {dispute.milestoneId?.name}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusBadge(dispute.status)}`}>
//                         {dispute.status.replace('-', ' ').toUpperCase()}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <FaCalendar className="mr-2 text-gray-400" size={16} />
//                         <span className="text-sm text-gray-900">
//                           {new Date(dispute.createdAt).toLocaleDateString()}
//                         </span>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <button
//                         onClick={() => fetchDisputeDetails(dispute._id)}
//                         className="inline-flex items-center px-3 py-2 border border-blue-300 text-sm leading-4 font-medium rounded-md text-blue-700 bg-white hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       >
//                         <FaEye className="mr-1" size={14} />
//                         View Details
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* Pagination */}
//       {pagination.total > 1 && (
//         <div className="flex justify-center items-center mt-6 space-x-4">
//           <button
//             disabled={pagination.current === 1}
//             onClick={() => fetchDisputes(pagination.current - 1)}
//             className="px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             Previous
//           </button>
//           <span className="text-sm text-gray-700">
//             Page {pagination.current} of {pagination.total}
//           </span>
//           <button
//             disabled={pagination.current === pagination.total}
//             onClick={() => fetchDisputes(pagination.current + 1)}
//             className="px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* Dispute Details Modal */}
//       {showModal && selectedDispute && (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
//           <div className="relative top-20 mx-auto p-5 border w-11/12 max-w-6xl shadow-lg rounded-md bg-white">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900 flex items-center">
//                 <FaExclamationTriangle className="mr-2 text-yellow-500" />
//                 Dispute Details - {selectedDispute.disputeCode}
//               </h3>
//               <button
//                 onClick={() => setShowModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <span className="text-2xl">&times;</span>
//               </button>
//             </div>

//             {/* Tab Navigation */}
//             <div className="border-b border-gray-200 mb-4">
//               <nav className="-mb-px flex">
//                 <button
//                   onClick={() => setActiveTab('details')}
//                   className={`py-2 px-4 border-b-2 font-medium text-sm ${
//                     activeTab === 'details'
//                       ? 'border-blue-500 text-blue-600'
//                       : 'border-transparent text-gray-500 hover:text-gray-700'
//                   }`}
//                 >
//                   Dispute Details
//                 </button>
//                 <button
//                   onClick={() => setActiveTab('resolution')}
//                   className={`py-2 px-4 border-b-2 font-medium text-sm ${
//                     activeTab === 'resolution'
//                       ? 'border-blue-500 text-blue-600'
//                       : 'border-transparent text-gray-500 hover:text-gray-700'
//                   }`}
//                 >
//                   Resolution
//                 </button>
//               </nav>
//             </div>

//             {/* Tab Content */}
//             {activeTab === 'details' && (
//               <div>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//                   {/* Dispute Information */}
//                   <div className="bg-gray-50 rounded-lg p-4">
//                     <h4 className="text-lg font-medium text-gray-900 mb-4 flex items-center">
//                       <FaUser className="mr-2" />
//                       Dispute Information
//                     </h4>
//                     <div className="space-y-3">
//                       <div>
//                         <label className="block text-sm font-medium text-gray-500">Dispute Code</label>
//                         <p className="text-sm font-semibold text-gray-900">{selectedDispute.disputeCode}</p>
//                       </div>
//                       <div>
//                         <label className="block text-sm font-medium text-gray-500">Created By</label>
//                         <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
//                           selectedDispute.raisedBy === 'client' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
//                         }`}>
//                           {selectedDispute.raisedBy.toUpperCase()}
//                         </span>
//                       </div>
//                       <div>
//                         <label className="block text-sm font-medium text-gray-500">Against User</label>
//                         <p className="text-sm text-gray-900">{selectedDispute.againstUser?.name}</p>
//                         <p className="text-xs text-gray-500">{selectedDispute.againstUser?.email}</p>
//                       </div>
//                       <div>
//                         <label className="block text-sm font-medium text-gray-500">Status</label>
//                         <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusBadge(selectedDispute.status)}`}>
//                           {selectedDispute.status.replace('-', ' ').toUpperCase()}
//                         </span>
//                       </div>
//                       <div>
//                         <label className="block text-sm font-medium text-gray-500">Created Date</label>
//                         <p className="text-sm text-gray-900">{new Date(selectedDispute.createdAt).toLocaleString()}</p>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Project Information */}
//                   <div className="bg-gray-50 rounded-lg p-4">
//                     <h4 className="text-lg font-medium text-gray-900 mb-4 flex items-center">
//                       <FaProjectDiagram className="mr-2" />
//                       Project Information
//                     </h4>
//                     <div className="space-y-3">
//                       <div>
//                         <label className="block text-sm font-medium text-gray-500">Project Title</label>
//                         <p className="text-sm font-semibold text-gray-900">{selectedDispute.projectId?.title}</p>
//                       </div>
//                       <div>
//                         <label className="block text-sm font-medium text-gray-500">Project Budget</label>
//                         <p className="text-sm text-gray-900">${selectedDispute.projectId?.budget}</p>
//                       </div>
//                       {selectedDispute.milestoneId && (
//                         <>
//                           <div>
//                             <label className="block text-sm font-medium text-gray-500">Milestone</label>
//                             <p className="text-sm text-gray-900">{selectedDispute.milestoneId?.name}</p>
//                           </div>
//                           <div>
//                             <label className="block text-sm font-medium text-gray-500">Milestone Amount</label>
//                             <p className="text-sm text-gray-900">${selectedDispute.milestoneId?.amount}</p>
//                           </div>
//                         </>
//                       )}
//                       <div>
//                         <label className="block text-sm font-medium text-gray-500">Project Status</label>
//                         <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
//                           {selectedDispute.projectId?.status?.toUpperCase()}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Dispute Reason */}
//                 <div className="bg-white border rounded-lg p-4 mb-6">
//                   <h4 className="text-lg font-medium text-gray-900 mb-3">Dispute Reason</h4>
//                   <p className="text-gray-700">{selectedDispute.resolutionDetails}</p>
//                 </div>

//                 {/* Attachments */}
//                 {selectedDispute.attachments && selectedDispute.attachments.length > 0 && (
//                   <div className="bg-white border rounded-lg p-4">
//                     <h4 className="text-lg font-medium text-gray-900 mb-4 flex items-center">
//                       <FaFileAlt className="mr-2" />
//                       Attachments ({selectedDispute.attachments.length})
//                     </h4>
//                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                       {selectedDispute.attachments.map((attachment, index) => (
//                         <div key={index} className="border border-gray-200 rounded-lg p-3">
//                           <div className="flex items-center mb-3">
//                             {getFileIcon(attachment.type)}
//                             <div className="ml-2 flex-1">
//                               <p className="text-sm font-medium text-gray-900 truncate">{attachment.name}</p>
//                               <p className="text-xs text-gray-500">{formatFileSize(attachment.size || 0)}</p>
//                             </div>
//                           </div>
//                           <div className="flex space-x-2">
//                             <button
//                               onClick={() => window.open(attachment.url, '_blank')}
//                               className="flex-1 px-3 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center justify-center"
//                             >
//                               <FaEye className="mr-1" size={12} />
//                               View
//                             </button>
//                             <button
//                               onClick={() => {
//                                 const link = document.createElement('a');
//                                 link.href = attachment.url;
//                                 link.download = attachment.name;
//                                 document.body.appendChild(link);
//                                 link.click();
//                                 document.body.removeChild(link);
//                               }}
//                               className="flex-1 px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700 flex items-center justify-center"
//                             >
//                               <FaDownload className="mr-1" size={12} />
//                               Download
//                             </button>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {activeTab === 'resolution' && (
//               <div>
//                 <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
//                   <p className="text-sm text-blue-800">
//                     <strong>Resolution Actions:</strong> Choose how to resolve this dispute. Your decision will trigger appropriate payment actions.
//                   </p>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">Status *</label>
//                     <select
//                       value={resolutionData.status}
//                       onChange={(e) => setResolutionData(prev => ({ ...prev, status: e.target.value }))}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     >
//                       <option value="">Select Status</option>
//                       <option value="under-review">Under Review</option>
//                       <option value="resolved">Resolved</option>
//                       <option value="rejected">Rejected</option>
//                     </select>
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">Admin Decision</label>
//                     <select
//                       value={resolutionData.adminDecision}
//                       onChange={(e) => setResolutionData(prev => ({ ...prev, adminDecision: e.target.value }))}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     >
//                       <option value="">Select Decision</option>
//                       <option value="refund">Full Refund</option>
//                       <option value="partial-refund">Partial Refund</option>
//                       <option value="release-payment">Release Payment</option>
//                       <option value="custom">Custom Solution</option>
//                     </select>
//                   </div>
//                 </div>

//                 <div className="mb-6">
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Resolution Notes</label>
//                   <textarea
//                     rows={4}
//                     value={resolutionData.resolutionNotes}
//                     onChange={(e) => setResolutionData(prev => ({ ...prev, resolutionNotes: e.target.value }))}
//                     placeholder="Provide detailed notes about your decision and any actions taken..."
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* Modal Footer */}
//             <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
//               <button
//                 onClick={() => setShowModal(false)}
//                 className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
//               >
//                 Close
//               </button>
//               {activeTab === 'resolution' && (
//                 <button
//                   onClick={updateDisputeStatus}
//                   disabled={resolving || !resolutionData.status}
//                   className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
//                 >
//                   {resolving ? (
//                     <>
//                       <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
//                       Updating...
//                     </>
//                   ) : (
//                     'Update Dispute'
//                   )}
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminDisputesDashboard;



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import store from '../../store/index';
import SpinnerLoader from '../../components/common/SpinnerLoader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import Header from '../../components/admin/common/Header';
import Footer from '../../components/common/Footer';
import { Link } from "react-router-dom";
import arrow_back from '../../assets/icons/arrow-back.svg';
import { Modal } from 'react-bootstrap';
import config from '../../config.json';

// Admin Chat Hook
const useAdminChat = () => {
    const history = useHistory();
    const [chatLoading, setChatLoading] = useState(false);
    const authInfo = JSON.parse(localStorage.getItem('authInfo'));
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    // Start chat with specific user
    const startChatWithUser = async (userId, userName, userImage, userRole) => {
        setChatLoading(true);

        try {
            console.log('Starting chat with:', { userId, userName, userImage, userRole });

            // First create/access the chat
            const response = await axios.post('/admin/accessChat', {
                receiverId: {
                    id: userId,
                    name: userName,
                    image_url: userImage || '',
                    role: userRole
                },
                authorId: {
                    id: authInfo.id,
                    name: userInfo.name,
                    image_url: userInfo.imgUrl || '',
                    role: 'Admin'
                }
            }, {
                headers: {
                    'Authorization': `Bearer ${authInfo.token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.data.status === true) {
                // Navigate to chat with specific user ID to auto-select
                history.push({
                    pathname: '/admin/chat',
                    state: {
                        targetUserId: userId,
                        chatType: 'dispute-support',
                        fromDispute: true,
                        autoSelectChat: true
                    }
                });
            } else {
                toast.error('Failed to start chat with user');
            }
        } catch (error) {
            console.error("Error starting chat:", error);
            toast.error('Unable to start chat with user');
        } finally {
            setChatLoading(false);
        }
    };

    const openGeneralChat = async () => {
        setChatLoading(true);

        try {
            history.push({
                pathname: '/admin/chat',
                state: {
                    chatType: 'dispute-support',
                    fromDispute: true
                }
            });
        } catch (error) {
            console.error("Error opening chat:", error);
            toast.error('Failed to open chat interface');
        } finally {
            setChatLoading(false);
        }
    };

    return { startChatWithUser, openGeneralChat, chatLoading };
};

const AdminDisputeDashboard = () => {
    const authInfo = store.getState().auth.authInfo;
    const { startChatWithUser, openGeneralChat, chatLoading } = useAdminChat();
    const [loading, setLoading] = useState(false);
    const [disputeList, setDisputeList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [currentDispute, setCurrentDispute] = useState(null);
    const [permissions, setPermissions] = useState({
        view: false,
        resolve: false,
        reject: false
    });
    const [viewModalShow, setViewModalShow] = useState(false);
    const [resolveModalShow, setResolveModalShow] = useState(false);
    const [statusChangeModalShow, setStatusChangeModalShow] = useState(false);
    const [filterStatus, setFilterStatus] = useState('all');

    // Helper function to extract user information from dispute
    const getUserInfo = (dispute, userType) => {
        console.log('Getting user info for:', userType, dispute);

        // Try multiple possible field names for IDs
        const possibleClientIds = [
            dispute.clientId,
            dispute.client?._id,
            dispute.client?.id,
            dispute.projectId?.clientId,
            dispute.projectId?.client?._id,
            dispute.projectId?.client?.id
        ];

        const possibleSellerIds = [
            dispute.sellerId,
            dispute.seller?._id,
            dispute.seller?.id,
            dispute.projectId?.sellerId,
            dispute.projectId?.seller?._id,
            dispute.projectId?.seller?.id
        ];

        // Client info logic
        if (userType === 'client') {
            let clientId = null;
            let clientName = 'Client';
            let clientImage = null;

            if (dispute.raisedBy === 'client') {
                // Client raised the dispute
                clientId = dispute.raisedByUserId || dispute.raisedByUser?._id || dispute.raisedByUser?.id;
                clientName = dispute.raisedByUser?.name || dispute.raisedByUser?.email || 'Client';
                clientImage = dispute.raisedByUser?.image_url || dispute.raisedByUser?.avatar;
            } else {
                // Seller raised dispute, client is the againstUser
                clientId = dispute.againstUserId || dispute.againstUser?._id || dispute.againstUser?.id;
                clientName = dispute.againstUserInfo?.name || dispute.againstUser?.name || dispute.againstUser?.email || 'Client';
                clientImage = dispute.againstUserInfo?.image_url || dispute.againstUser?.image_url || dispute.againstUser?.avatar;
            }

            // Fallback to project-level client info
            if (!clientId) {
                clientId = possibleClientIds.find(id => id) || null;
            }
            if (clientName === 'Client') {
                clientName = dispute.client?.name || dispute.projectId?.client?.name || 'Client';
            }
            if (!clientImage) {
                clientImage = dispute.client?.image_url || dispute.projectId?.client?.image_url;
            }

            return {
                id: clientId,
                name: clientName,
                image: clientImage,
                role: 'User'
            };
        }

        // Seller info logic
        if (userType === 'seller') {
            let sellerId = null;
            let sellerName = 'Seller';
            let sellerImage = null;

            if (dispute.raisedBy === 'seller') {
                // Seller raised the dispute
                sellerId = dispute.raisedByUserId || dispute.raisedByUser?._id || dispute.raisedByUser?.id;
                sellerName = dispute.raisedByUser?.name || dispute.raisedByUser?.email || 'Seller';
                sellerImage = dispute.raisedByUser?.image_url || dispute.raisedByUser?.avatar;
            } else {
                // Client raised dispute, seller is the againstUser
                sellerId = dispute.againstUserId || dispute.againstUser?._id || dispute.againstUser?.id;
                sellerName = dispute.againstUserInfo?.name || dispute.againstUser?.name || dispute.againstUser?.email || 'Seller';
                sellerImage = dispute.againstUserInfo?.image_url || dispute.againstUser?.image_url || dispute.againstUser?.avatar;
            }

            // Fallback to project-level seller info
            if (!sellerId) {
                sellerId = possibleSellerIds.find(id => id) || null;
            }
            if (sellerName === 'Seller') {
                sellerName = dispute.seller?.name || dispute.projectId?.seller?.name || 'Seller';
            }
            if (!sellerImage) {
                sellerImage = dispute.seller?.image_url || dispute.projectId?.seller?.image_url;
            }

            return {
                id: sellerId,
                name: sellerName,
                image: sellerImage,
                role: 'Seller'
            };
        }

        return { id: null, name: 'Unknown', image: null, role: 'User' };
    };

    // Define columns with chat buttons
    const dispute_columns = [
        {
            name: 'Dispute Code',
            selector: (row) => row.disputeCode,
            sortable: true,
            width: '120px'
        },
        {
            name: 'Project ID',
            selector: (row) => row.projectId?.title || row.projectId || 'N/A',
            sortable: true,
            width: '160px'
        },
        {
            name: 'Milestone',
            selector: (row) => row.milestoneId?.title || row.milestoneId?.name || 'General',
            sortable: true,
            width: '120px'
        },
        {
            name: 'Raised By',
            selector: (row) => (
                <span className={`badge ${row.raisedBy === 'client' ? 'bg-info' : 'bg-warning'}`}>
                    {row.raisedBy === 'client' ? 'Client' : 'Seller'}
                </span>
            ),
            sortable: true,
            width: '100px'
        },
        {
            name: 'Status',
            selector: (row) => {
                const statusColors = {
                    'open': 'bg-danger',
                    'under-review': 'bg-warning',
                    'resolved': 'bg-success',
                    'rejected': 'bg-secondary'
                };
                return (
                    <span className={`badge ${statusColors[row.status]}`}>
                        {row.status.toUpperCase().replace('-', ' ')}
                    </span>
                );
            },
            sortable: true,
            width: '100px'
        },
        {
            name: 'Created Date',
            selector: (row) => new Date(row.createdAt).toLocaleDateString(),
            sortable: true,
            width: '100px'
        },
        {
            name: "Chat Actions",
            cell: (row) => {
                const clientInfo = getUserInfo(row, 'client');
                const sellerInfo = getUserInfo(row, 'seller');

                return (
                    <div className="d-flex gap-1 flex-row" style={{ whiteSpace: 'nowrap' }}>
                        <button
                            className={`btn btn-outline-info btn-sm px-2 py-1 ${!clientInfo.id ? 'disabled' : ''}`}
                            onClick={() => {
                                if (clientInfo.id) {
                                    console.log('Starting chat with client:', clientInfo);
                                    startChatWithUser(clientInfo.id, clientInfo.name, clientInfo.image, clientInfo.role);
                                } else {
                                    toast.warning('Client information not available for this dispute');
                                }
                            }}
                            disabled={chatLoading || !clientInfo.id}
                            title={clientInfo.id ? `Chat with ${clientInfo.name}` : 'Client info not available'}
                            style={{ fontSize: '11px', minWidth: '80px' }}
                        >
                            💬 Client
                        </button>
                        <button
                            className={`btn btn-outline-success btn-sm px-2 py-1 ${!sellerInfo.id ? 'disabled' : ''}`}
                            onClick={() => {
                                if (sellerInfo.id) {
                                    console.log('Starting chat with seller:', sellerInfo);
                                    startChatWithUser(sellerInfo.id, sellerInfo.name, sellerInfo.image, sellerInfo.role);
                                } else {
                                    toast.warning('Seller information not available for this dispute');
                                }
                            }}
                            disabled={chatLoading || !sellerInfo.id}
                            title={sellerInfo.id ? `Chat with ${sellerInfo.name}` : 'Seller info not available'}
                            style={{ fontSize: '11px', minWidth: '80px' }}
                        >
                            💬 Seller
                        </button>
                    </div>
                );
            },
            width: '200px'
        },
        {
            name: "Actions",
            cell: (row) => {
                return (
                    <div className="d-flex gap-1" style={{ whiteSpace: 'nowrap', flexWrap: 'nowrap' }}>
                        <button
                            className="btn btn-outline-primary btn-sm px-2 py-1"
                            onClick={() => handleView(row)}
                            disabled={!permissions.view}
                            title="View Details"
                            style={{ fontSize: '11px', minWidth: '45px' }}
                        >
                            View
                        </button>
                        {row.status !== 'resolved' && row.status !== 'rejected' && (
                            <>
                                <button
                                    className="btn btn-outline-success btn-sm px-2 py-1"
                                    onClick={() => handleResolve(row)}
                                    disabled={!permissions.resolve}
                                    title="Resolve Dispute"
                                    style={{ fontSize: '11px', minWidth: '50px' }}
                                >
                                    Resolve
                                </button>
                                <button
                                    className="btn btn-outline-danger btn-sm px-2 py-1"
                                    onClick={() => handleReject(row)}
                                    disabled={!permissions.reject}
                                    title="Reject Dispute"
                                    style={{ fontSize: '11px', minWidth: '45px' }}
                                >
                                    Reject
                                </button>
                            </>
                        )}
                        <button
                            className="btn btn-outline-warning btn-sm px-2 py-1"
                            onClick={() => handleStatusChange(row)}
                            disabled={!permissions.resolve}
                            title="Change Status"
                            style={{ fontSize: '11px', minWidth: '50px' }}
                        >
                            Status
                        </button>
                    </div>

                );
            },
            width: '220px'
        }
    ];

    useEffect(() => {
        getDisputePermissions();
        fetchDisputeList();
    }, []);

    const getDisputePermissions = async () => {
        const admin_Id = authInfo.id;
        try {
            const res = await axios.get(`admin/getDisputePermission/${admin_Id}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            });

            if (res.data.status === true && res.data.data) {
                setPermissions(res.data.data);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error fetching permissions');
            console.error("Error fetching permissions: ", error);
        }
    };

    // UPDATED: Fetch dispute list with detailed milestone and project info
    const fetchDisputeList = async ({ page = 1, limit = 10, status = 'all', raisedBy = 'all', adminDecision = 'all', search = '' } = {}) => {
        setLoading(true);
        try {
            const response = await axios.get("/admin/disputes", {
            params: { page, limit, status, raisedBy, adminDecision, search },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Bearer ${authInfo.token}`
            }
            });

            const { data, pagination, status: success, message } = response.data;

            if (!success) {
            toast.error(message || 'Failed to fetch dispute list');
            return;
            }

            setDisputeList(data); // data is already enhanced by backend
            //setPagination(pagination); // Optional: if you want to handle pagination
        } catch (error) {
            console.error("Error fetching dispute data", error);
            toast.error("Error fetching dispute data");
        } finally {
            setLoading(false);
        }
        };


    const handleSetUnderReview = async (row) => {
        try {
            const response = await axios.put(`/admin/disputes/status/${row._id}`, { status: 'under-review' }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            });

            if (response.data.status === true) {
                toast.success(response.data.message);
                await fetchDisputeList();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Error updating status", error);
            toast.error(error.response?.data?.message || "Error updating status");
        }
    };

    const updateDisputeStatus = async (values, { setSubmitting }) => {
        try {
            const response = await axios.put(`/admin/disputes/status/${currentDispute._id}`, {
                status: values.status,
                reason: values.reason
            },
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            });

            if (response.data.status === true) {
                toast.success(response.data.message);
                await fetchDisputeList();
                setCurrentDispute(null);
                setStatusChangeModalShow(false);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error updating dispute status', error);
            toast.error(error.response?.data?.message || 'Error updating dispute status');
        } finally {
            setSubmitting(false);
        }
    };

    // UPDATED: Resolve dispute with refund functionality
    const resolveDispute = async (values, { setSubmitting }) => {
        try {
            const payload = {
                disputeId: currentDispute._id,
                adminDecision: values.adminDecision,
                resolutionDetails: values.resolutionDetails,
                milestoneId: currentDispute.milestoneDetails.id,
                projectId: currentDispute.projectDetails.id
            };

            // Add refund-specific data if refund is selected
            if (values.adminDecision === 'partial-refund') {
                payload.refundDetails = {
                    refundType: values.refundType,
                    refundAmount: parseFloat(values.refundAmount),
                    milestoneAmount: currentDispute.milestoneDetails.amount,
                    stripePaymentIntentId: currentDispute.milestoneDetails.stripePaymentIntentId,
                    paymentStatus: currentDispute.milestoneDetails.paymentStatus
                };
            }

            const response = await axios.post('/admin/disputes/resolve', payload, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': `Bearer ${authInfo.token}`
                }
            });

            if (response.data.status) {
                toast.success(response.data.message || 'Dispute resolved successfully');
                await fetchDisputeList();
                setCurrentDispute(null);
                setResolveModalShow(false);
            } else {
                toast.error(response.data.message || 'Failed to resolve dispute');
            }
        } catch (error) {
            console.error('Error resolving dispute:', error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error('An error occurred while resolving the dispute');
            }
        } finally {
            setSubmitting(false);
        }
    };

    const handleReject = async (row) => {
        if (window.confirm('Are you sure you want to reject this dispute?')) {
            try {
                const response = await axios.put(`/admin/disputes/reject/${row._id}`, {}, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        'Authorization': `Bearer ${authInfo.token}`
                    }
                });

                if (response.data.status === true) {
                    toast.success(response.data.message);
                    await fetchDisputeList();
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                console.error("Error rejecting dispute", error);
                toast.error(error.response?.data?.message || "Error rejecting dispute");
            }
        }
    };

    const handleRowSelected = (state) => {
        setSelectedRows(state.selectedRows);
    };

    const handleView = (row) => {
        setCurrentDispute(row);
        setViewModalShow(true);
    };

    const handleResolve = (row) => {
        setCurrentDispute(row);
        setResolveModalShow(true);
    };

    const handleStatusChange = (row) => {
        setCurrentDispute(row);
        setStatusChangeModalShow(true);
    };

    const handleCloseViewModal = () => {
        setViewModalShow(false);
        setCurrentDispute(null);
    };

    const handleCloseResolveModal = () => {
        setResolveModalShow(false);
        setCurrentDispute(null);
    };

    const handleCloseStatusChangeModal = () => {
        setStatusChangeModalShow(false);
        setCurrentDispute(null);
    };

    // Filter disputes based on status
    const filteredDisputes = filterStatus === 'all'
        ? disputeList
        : disputeList.filter(dispute => dispute.status === filterStatus);

    // UPDATED: Form validation schemas with proper refund validation
    const resolveValidationSchema = Yup.object({
        resolutionDetails: Yup.string()
            .required('Resolution details are required')
            .min(10, 'Resolution details must be at least 10 characters'),
        adminDecision: Yup.string()
            .required('Admin decision is required')
            .oneOf(['partial-refund', 'release-payment', 'custom'], 'Invalid decision type'),
        refundType: Yup.string()
            .when('adminDecision', {
                is: 'partial-refund',
                then: Yup.string().required('Refund type is required'),
                otherwise: Yup.string()
            }),
        refundAmount: Yup.number()
            .when('adminDecision', {
                is: 'partial-refund',
                then: Yup.number()
                    .required('Refund amount is required')
                    .min(0.01, 'Refund amount must be greater than 0')
                    .test('max-amount', 'Refund amount cannot exceed milestone amount', function(value) {
                        const milestoneAmount = this.parent.milestoneAmount || 0;
                        return value <= milestoneAmount;
                    }),
                otherwise: Yup.number()
            })
    });

    const statusChangeValidationSchema = Yup.object({
        status: Yup.string()
            .required('Status is required')
            .oneOf(['open', 'under-review', 'resolved', 'rejected'], 'Invalid status'),
        reason: Yup.string()
            .required('Reason for status change is required')
            .min(10, 'Reason must be at least 10 characters')
    });

    return (
        <React.Fragment>
            <div className="seller_dash_wrap pb-5">
                <div className="container">
                    <Header />
                    <Helmet>
                        <title>{"Admin - Manage Disputes - Pay Earth"}</title>
                    </Helmet>
                    <div className="inr_top_page_title">
                        <h2>Manage Disputes</h2>
                    </div>

                    {/* Loading indicator for chat */}
                    {chatLoading && (
                        <div className="alert alert-info">
                            Starting chat session...
                        </div>
                    )}

                    {/* View Dispute Modal */}
                    <Modal show={viewModalShow} onHide={handleCloseViewModal} size="xl">
                        <div className="createpost bg-white rounded-3 addPost_left_container">
                            <Modal.Header closeButton>
                                <div className="cp_top">
                                    <Modal.Title>
                                        <div className="cumm_title">
                                            DISPUTE DETAILS - {currentDispute?.disputeCode}
                                        </div>
                                    </Modal.Title>
                                </div>
                            </Modal.Header>
                            <Modal.Body>
                                {currentDispute && (
                                    <div className="cp_body">
                                        {/* Chat buttons in modal */}
                                        {/* <div className="row mb-4">
                                            <div className="col-12">
                                                <div className="d-flex gap-2 justify-content-end">
                                                    <button
                                                        className={`btn btn-sm ${getUserInfo(currentDispute, 'client').id ? 'btn-info' : 'btn-secondary'}`}
                                                        onClick={() => {
                                                            const clientInfo = getUserInfo(currentDispute, 'client');
                                                            if (clientInfo.id) {
                                                                console.log('Modal client chat:', clientInfo);
                                                                //startChatWithUser(clientInfo.id, clientInfo.name, clientInfo.image, clientInfo.role);
                                                            } else {
                                                                toast.warning('Client ID not found for this dispute');
                                                            }
                                                        }}
                                                        disabled={chatLoading}
                                                        title={getUserInfo(currentDispute, 'client').id ? `Chat with ${getUserInfo(currentDispute, 'client').name}` : 'Client ID not available'}
                                                    >
                                                        💬 Chat with Client
                                                    </button>
                                                    <button
                                                        className={`btn btn-sm ${getUserInfo(currentDispute, 'seller').id ? 'btn-success' : 'btn-secondary'}`}
                                                        onClick={() => {
                                                            const sellerInfo = getUserInfo(currentDispute, 'seller');
                                                            if (sellerInfo.id) {
                                                                console.log('Modal seller chat:', sellerInfo);
                                                                //startChatWithUser(sellerInfo.id, sellerInfo.name, sellerInfo.image, sellerInfo.role);
                                                            } else {
                                                                toast.warning('Seller ID not found for this dispute');
                                                            }
                                                        }}
                                                        disabled={chatLoading}
                                                        title={getUserInfo(currentDispute, 'seller').id ? `Chat with ${getUserInfo(currentDispute, 'seller').name}` : 'Seller ID not available'}
                                                    >
                                                        💬 Chat with Seller
                                                    </button>
                                                </div>
                                            </div>
                                        </div> */}

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <strong>Dispute Code:</strong> {currentDispute.disputeCode}
                                                </div>
                                                <div className="mb-3">
                                                    <strong>Project:</strong> {currentDispute.projectDetails?.title || 'N/A'}
                                                </div>
                                                <div className="mb-3">
                                                    <strong>Milestone:</strong> {currentDispute.milestoneDetails?.name || 'General'}
                                                </div>
                                                <div className="mb-3">
                                                    <strong>Milestone Amount:</strong> ${currentDispute.milestoneDetails?.amount || 0}
                                                </div>
                                                <div className="mb-3">
                                                    <strong>Payment Status:</strong>
                                                    <span className="badge bg-info ms-2">
                                                        {currentDispute.milestoneDetails?.paymentStatus || 'Unknown'}
                                                    </span>
                                                </div>
                                                <div className="mb-3">
                                                    <strong>Raised By:</strong>
                                                    <span className={`badge ms-2 ${currentDispute.raisedBy === 'client' ? 'bg-info' : 'bg-warning'}`}>
                                                        {currentDispute.raisedBy === 'client' ? 'Client' : 'Seller'}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <strong>Against User:</strong> {currentDispute.againstUser?.name || currentDispute.againstUser?.email || 'N/A'}
                                                </div>
                                                <div className="mb-3">
                                                    <strong>Status:</strong>
                                                    <span className={`badge ms-2 ${
                                                        currentDispute.status === 'open' ? 'bg-danger' :
                                                        currentDispute.status === 'under-review' ? 'bg-warning' :
                                                        currentDispute.status === 'resolved' ? 'bg-success' : 'bg-secondary'
                                                    }`}>
                                                        {currentDispute.status.toUpperCase().replace('-', ' ')}
                                                    </span>
                                                </div>
                                                <div className="mb-3">
                                                    <strong>Admin Decision:</strong> {currentDispute.adminDecision?.replace('-', ' ')?.toUpperCase() || 'Pending'}
                                                </div>
                                                <div className="mb-3">
                                                    <strong>Created:</strong> {new Date(currentDispute.createdAt).toLocaleString()}
                                                </div>
                                                {console.log("CURRECT DISPUTE", currentDispute)}
                                                {currentDispute.milestoneDetails?.stripePaymentIntentId && (
                                                    <div className="mb-3">
                                                        <strong>Stripe Payment ID:</strong>
                                                        <small className="text-muted d-block">
                                                            {currentDispute.milestoneDetails.stripePaymentIntentId}
                                                        </small>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Dispute Description */}
                                        {currentDispute.description && (
                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <strong>Dispute Description:</strong>
                                                        <div className="mt-2 p-3 bg-light rounded">
                                                            {currentDispute.description}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Debug info - remove in production */}
                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <div className="small text-muted">
                                                    <strong>Details:</strong><br/>
                                                    Client ID: {getUserInfo(currentDispute, 'client').id}<br/>
                                                    Seller ID: {getUserInfo(currentDispute, 'seller').id}<br/>
                                                    {/* Raised By User ID: {currentDispute.raisedByUserId}<br/>
                                                    Against User ID: {currentDispute.againstUserId} */}
                                                </div>
                                            </div>
                                        </div>

                                        {currentDispute.resolutionDetails && (
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <strong>Resolution Details:</strong>
                                                        <div className="mt-2 p-3 bg-light rounded">
                                                            {currentDispute.resolutionDetails}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {currentDispute.attachments && currentDispute.attachments.length > 0 && (
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <strong>Attachments:</strong>
                                                        <div className="mt-2">
                                                            {currentDispute.attachments.map((attachment, index) => (
                                                                <div key={index} className="mb-2">
                                                                    <a
                                                                        href={`${config.apiURI}${attachment.url.startsWith('/') ? attachment.url.substring(1) : attachment.url}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="btn btn-sm btn-outline-primary"
                                                                    >
                                                                        📎 {attachment.name}
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Modal.Body>
                        </div>
                    </Modal>

                    {/* Resolve Dispute Modal */}
                    <Modal show={resolveModalShow} onHide={handleCloseResolveModal} size="lg">
                        <div className="createpost bg-white rounded-3 addPost_left_container">
                            <Modal.Header closeButton>
                                <div className="cp_top">
                                    <Modal.Title>
                                        <div className="cumm_title">
                                            RESOLVE DISPUTE - {currentDispute?.disputeCode}
                                        </div>
                                    </Modal.Title>
                                </div>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="cp_body">
                                    {currentDispute && (
                                        <Formik
                                            initialValues={{
                                                resolutionDetails: '',
                                                adminDecision: 'custom',
                                                refundAmount: currentDispute?.milestoneDetails?.amount || 0,
                                                refundType: 'full',
                                                milestoneAmount: currentDispute?.milestoneDetails?.amount || 0
                                            }}
                                            validationSchema={resolveValidationSchema}
                                            onSubmit={resolveDispute}
                                        >
                                            {({ values, setFieldValue, isSubmitting }) => (
                                                <Form>
                                                    {/* Dispute Information Display */}
                                                    <div className="row mb-3">
                                                        <div className="col-12">
                                                            <div className="alert alert-info">
                                                                <h6>Dispute Details:</h6>
                                                                <p><strong>Project:</strong> {currentDispute?.projectDetails?.title}</p>
                                                                <p><strong>Milestone:</strong> {currentDispute?.milestoneDetails?.name}</p>
                                                                <p><strong>Milestone Amount:</strong> ${currentDispute?.milestoneDetails?.amount}</p>
                                                                <p><strong>Payment Status:</strong> {currentDispute?.milestoneDetails?.paymentStatus}</p>
                                                                {currentDispute?.milestoneDetails?.stripePaymentIntentId && (
                                                                    <p><strong>Stripe Payment ID:</strong> {currentDispute?.milestoneDetails?.stripePaymentIntentId}</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="crt_bnr_fieldRow">
                                                                <div className="crt_bnr_field">
                                                                    <label htmlFor="adminDecision">Admin Decision</label>
                                                                    <div className="field_item">
                                                                        <Field
                                                                            as="select"
                                                                            className="form-control"
                                                                            name="adminDecision"
                                                                            onChange={(e) => {
                                                                                setFieldValue('adminDecision', e.target.value);
                                                                                // Reset refund amount when decision changes
                                                                                if (e.target.value === 'partial-refund') {
                                                                                    setFieldValue('refundAmount', currentDispute?.milestoneDetails?.amount || 0);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <option value="custom">Custom Resolution</option>
                                                                            <option value="partial-refund">Refund to Client</option>
                                                                            <option value="release-payment">Release Payment to Seller</option>
                                                                        </Field>
                                                                        <ErrorMessage name="adminDecision" component="div" className="text-danger" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Refund Options - Show only when refund is selected */}
                                                    {values.adminDecision === 'partial-refund' && (
                                                        <>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="crt_bnr_fieldRow">
                                                                        <div className="crt_bnr_field">
                                                                            <label htmlFor="refundType">Refund Type</label>
                                                                            <div className="field_item">
                                                                                <Field
                                                                                    as="select"
                                                                                    className="form-control"
                                                                                    name="refundType"
                                                                                    onChange={(e) => {
                                                                                        setFieldValue('refundType', e.target.value);
                                                                                        if (e.target.value === 'full') {
                                                                                            setFieldValue('refundAmount', currentDispute?.milestoneDetails?.amount || 0);
                                                                                        } else {
                                                                                            setFieldValue('refundAmount', 0);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <option value="full">Full Refund</option>
                                                                                    <option value="partial">Partial Refund</option>
                                                                                </Field>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="crt_bnr_fieldRow">
                                                                        <div className="crt_bnr_field">
                                                                            <label htmlFor="refundAmount">
                                                                                Refund Amount (Max: ${currentDispute?.milestoneDetails?.amount})
                                                                            </label>
                                                                            <div className="field_item">
                                                                                <Field
                                                                                    type="number"
                                                                                    className="form-control"
                                                                                    name="refundAmount"
                                                                                    min="0"
                                                                                    max={currentDispute?.milestoneDetails?.amount}
                                                                                    step="0.01"
                                                                                    disabled={values.refundType === 'full'}
                                                                                    placeholder="Enter refund amount"
                                                                                />
                                                                                <ErrorMessage name="refundAmount" component="div" className="text-danger" />
                                                                                <small className="text-muted">
                                                                                    {values.refundType === 'full'
                                                                                        ? 'Full milestone amount will be refunded'
                                                                                        : 'Enter the amount to refund to the client'
                                                                                    }
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Warning for refund */}
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="alert alert-warning">
                                                                        <i className="fa fa-exclamation-triangle me-2"></i>
                                                                        <strong>Warning:</strong> This action will process a refund through Stripe.
                                                                        Please ensure all dispute details have been reviewed carefully.
                                                                        {currentDispute?.milestoneDetails?.paymentStatus === 'released' && (
                                                                            <div className="mt-2">
                                                                                <strong>Note:</strong> Payment has already been released to the seller.
                                                                                This refund will require clawback from the seller's account.
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="crt_bnr_fieldRow">
                                                                <div className="crt_bnr_field">
                                                                    <label htmlFor="resolutionDetails">Resolution Details</label>
                                                                    <div className="field_item">
                                                                        <Field
                                                                            as="textarea"
                                                                            className="form-control"
                                                                            name="resolutionDetails"
                                                                            rows="5"
                                                                            placeholder="Provide detailed explanation of the resolution..."
                                                                        />
                                                                        <ErrorMessage name="resolutionDetails" component="div" className="text-danger" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="filter_btn_box text-center">
                                                        <button
                                                            type="button"
                                                            className='btn custom_btn btn_yellow_bordered me-2'
                                                            onClick={handleCloseResolveModal}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className={`btn custom_btn btn_yellow_bordered me-2`}
                                                            type="submit"
                                                            disabled={isSubmitting}
                                                        >
                                                            {isSubmitting ? "Processing..." :
                                                            values.adminDecision === 'partial-refund' ? "Process Refund" :
                                                            "Resolve Dispute"}
                                                        </button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    )}
                                </div>
                            </Modal.Body>
                        </div>
                    </Modal>

                    {/* Change Status Modal */}
                    <Modal show={statusChangeModalShow} onHide={handleCloseStatusChangeModal} size="lg">
                        <div className="createpost bg-white rounded-3 addPost_left_container">
                            <Modal.Header closeButton>
                                <div className="cp_top">
                                    <Modal.Title>
                                        <div className="cumm_title">
                                            CHANGE DISPUTE STATUS - {currentDispute?.disputeCode}
                                        </div>
                                    </Modal.Title>
                                </div>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="cp_body">
                                    {currentDispute && (
                                        <Formik
                                            initialValues={{
                                                status: currentDispute.status,
                                                reason: ''
                                            }}
                                            validationSchema={statusChangeValidationSchema}
                                            onSubmit={updateDisputeStatus}
                                        >
                                            {({ isSubmitting, values }) => (
                                                <Form>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="mb-3">
                                                                <strong>Current Status:</strong>
                                                                <span className={`badge ms-2 ${
                                                                    currentDispute.status === 'open' ? 'bg-danger' :
                                                                    currentDispute.status === 'under-review' ? 'bg-warning' :
                                                                    currentDispute.status === 'resolved' ? 'bg-success' : 'bg-secondary'
                                                                }`}>
                                                                    {currentDispute.status.toUpperCase().replace('-', ' ')}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="crt_bnr_fieldRow">
                                                                <div className="crt_bnr_field">
                                                                    <label htmlFor="status">New Status</label>
                                                                    <div className="field_item">
                                                                        <Field
                                                                            as="select"
                                                                            className="form-control"
                                                                            name="status"
                                                                        >
                                                                            <option value="open">Open</option>
                                                                            <option value="under-review">Under Review</option>
                                                                            <option value="resolved">Resolved</option>
                                                                            <option value="rejected">Rejected</option>
                                                                        </Field>
                                                                        <ErrorMessage name="status" component="div" className="text-danger" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="crt_bnr_fieldRow">
                                                                <div className="crt_bnr_field">
                                                                    <label htmlFor="reason">Reason for Status Change</label>
                                                                    <div className="field_item">
                                                                        <Field
                                                                            as="textarea"
                                                                            className="form-control"
                                                                            name="reason"
                                                                            rows="4"
                                                                            placeholder="Explain why you are changing the status..."
                                                                        />
                                                                        <ErrorMessage name="reason" component="div" className="text-danger" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Show warning if changing to resolved/rejected */}
                                                    {(values.status === 'resolved' || values.status === 'rejected') && (
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="alert alert-warning">
                                                                    <strong>Warning:</strong> Changing status to "{values.status}" will finalize this dispute.
                                                                    {values.status === 'resolved' && ' Consider using the "Resolve" button for more detailed resolution options.'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="filter_btn_box text-center">
                                                        <button
                                                            type="button"
                                                            className='btn custom_btn btn_yellow_bordered me-2'
                                                            onClick={handleCloseStatusChangeModal}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className='btn custom_btn btn_yellow_bordered me-2'
                                                            type="submit"
                                                            disabled={isSubmitting}
                                                        >
                                                            {isSubmitting ? "Updating..." : "Update Status"}
                                                        </button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    )}
                                </div>
                            </Modal.Body>
                        </div>
                    </Modal>

                    {/* Dispute List */}
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="createpost bg-white rounded-3 addPost_left_container">
                                <div className="cp_top">
                                    <div className="d-flex ml-auto justify-content-between gap-2">
                                        <div className="cumm_title">Dispute List</div>
                                        <div className="d-flex justify-content-end ml-auto gap-2">
                                            <select
                                                className="form-select"
                                                value={filterStatus}
                                                onChange={(e) => setFilterStatus(e.target.value)}
                                                style={{ width: 'auto' }}
                                            >
                                                <option value="all">All Status</option>
                                                <option value="open">Open</option>
                                                <option value="under-review">Under Review</option>
                                                <option value="resolved">Resolved</option>
                                                <option value="rejected">Rejected</option>
                                            </select>
                                            <div className=''>
                                                <button
                                                    type="button"
                                                    className="btn custum_back_btn btn_yellow mx-auto"
                                                    onClick={() => window.history.back()}
                                                >
                                                    <img src={arrow_back} alt="back" />&nbsp;
                                                    Back
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="cp_body">
                                    {loading && <SpinnerLoader />}
                                    <DataTableExtensions
                                        columns={dispute_columns}
                                        data={filteredDisputes}
                                    >
                                        <DataTable
                                            pagination
                                            noHeader
                                            highlightOnHover
                                            defaultSortField="createdAt"
                                            defaultSortAsc={false}
                                            selectableRows
                                            selectedRows={selectedRows}
                                            onSelectedRowsChange={handleRowSelected}
                                        />
                                    </DataTableExtensions>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    );
};

export default AdminDisputeDashboard;
